import humps from 'humps'
import { k6api } from '@/api/k6-api'
import {
  AnalyzeRankingRequest,
  AnalyzeRankingResponse,
} from '@/types/schema/k6/analyze-api'

const analyzeApi = k6api.injectEndpoints({
  endpoints: (build) => ({
    analyzeRanking: build.query<AnalyzeRankingResponse, AnalyzeRankingRequest>({
      query: (params) => {
        return {
          url: `/analyze/ranking`,
          params: humps.decamelizeKeys(params),
        }
      },
      transformResponse: (response: object) => {
        return humps.camelizeKeys(response) as unknown as AnalyzeRankingResponse
      },
    }),
    analyzeTop10Ranking: build.query<
      AnalyzeRankingResponse,
      AnalyzeRankingRequest
    >({
      query: (params) => {
        return {
          url: `/analyze/top10-ranking`,
          params: humps.decamelizeKeys(params),
        }
      },
      transformResponse: (response: object) => {
        return humps.camelizeKeys(response) as unknown as AnalyzeRankingResponse
      },
    }),
  }),
  overrideExisting: false,
})

export const { useAnalyzeTop10RankingQuery, useAnalyzeRankingQuery } =
  analyzeApi
